import { span } from "lqx-react";
import * as React from "react";

export const CountListSection = ({ countAll, countFiltered }: { countAll: Number, countFiltered: Number }) => {

    return <>
        {
            countFiltered 
                ?   countFiltered === countAll
                    ? <CountSection>{countAll} items</CountSection>
                    : <CountSection>{countFiltered} of {countAll} items</CountSection>
                : <></>
        }
    </>
};

const CountSection = span({
    padding: '0 0 5px 11px',
    color: 'grey',
    fontSize: '14px'
});
